<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white d-flex align-items-center"
    >
      Data Peserta
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3 pr-xl-4 pr-sm-0">
          <!-- Tabs -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Profile Settings</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                  style="color:#2F3AAA;font-weight:bold"
                >Data Diri</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-anggota/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Anggota</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-dokumen/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Dokumen Pendukung</router-link>
              </li>
            </ul>
          </div>
          <button
            type="button"
            class="btn btn-success btn-block btn-md text-white text-bold"
            @click="modalVerif = true"
          >
            <i class="fa fa-paper-plane" aria-hidden="true"></i> verifikasi
          </button>
          <button
            type="button"
            class="btn btn-warning btn-block btn-md text-white text-bold"
            @click="sendEmail()"
          >
            <i class="fa fa-envelope" aria-hidden="true"></i> Kirim Email
          </button>
          <p
            class="text-danger font-weight-bold text-center mt-2"
            v-if="formData.statusDataDiri == '0'"
          >Status : Data Belum Terverifikasi</p>
          <p
            class="text-success font-weight-bold text-center mt-2"
            v-else-if="formData.statusDataDiri == '1'"
          >Status : Data Terverifikasi</p>
        </div>
        <!-- ./col -->
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Data Diri</h5>

            <div class="card-body border-0">
              <!-- <form action="#" method="post" enctype="multipart/form-data"> -->
              <div class="row">
                <div class="col-md-8 order-2 order-sm-2 order-md-1 order-lg-1 order-xl-1">
                  <form id="form-data" @submit.prevent="updateDataDiri">
                    <input type="hidden" name="user_id" />
                    <div class="form-group row">
                      <label
                        for="inputNama"
                        class="col-sm col-form-label"
                        style="font-size:15px"
                      >Nama (sesuai Ijazah)</label>
                      <div class="col-sm-8">
                        <input
                          type="text"
                          class="form-control"
                          name="nama"
                          v-model="details.nama"
                          id="inputNama"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputHP"
                        class="col-sm col-form-label"
                        style="font-size:15px"
                      >No. Handphone</label>
                      <div class="col-sm-8">
                        <input
                          type="number"
                          class="form-control"
                          name="hp"
                          v-model="details.no_handphone"
                          id="inputHP"
                        />
                        <p
                          style="color:red;margin-top:5px;font-size:12px"
                        >Nomor telepon seluler yang aktif</p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:15px"
                      >Email</label>
                      <div class="col-sm-8">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          id="inputEmail"
                          v-model="details.email"
                          autocomplete="email"
                        />
                        <p
                          style="color:red;margin-top:5px;font-size:12px"
                        >Email yang aktif dan diusahakan email pribadi</p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputTtl"
                        class="col-sm col-form-label"
                        style="font-size:15px"
                      >Tempat Lahir</label>
                      <div class="col-sm-8">
                        <input
                          type="text"
                          class="form-control"
                          name="ttl"
                          v-model="details.tempat_lahir"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputTtl"
                        class="col-sm col-form-label"
                        style="font-size:15px"
                      >Tanggal Lahir</label>
                      <div class="col-sm-8">
                        <input
                          type="date"
                          class="form-control"
                          name="ttl"
                          v-model="details.tanggal_lahir"
                          id="inputTtl"
                        />
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:15px"
                      >Jenis Kelamin</label>
                      <div class="col-sm-8">
                        <select name="jenkel" class="form-control" v-model="details.jenis_kelamin">
                          <option value="Laki - Laki">Laki - Laki</option>
                          <option value="Perempuan">Perempuan</option>
                        </select>
                      </div>
                    </div>
                    <div class="text-right">
                      <button class="btn btn-md btn-success mt-5">Update</button>
                    </div>
                    <!-- <input type="hidden" name="status" /> -->
                  </form>
                </div>
                <div class="col-md-4 order-1 order-sm-1 order-md-2 order-lg-2 order-xl-2">
                  <div
                    class="text-center"
                    v-if="formData.imageFile == null || formData.imageFile == ''"
                  >
                    <img
                      src="/img/avatars/2.jpeg"
                      style="width:150px"
                      class="card-img-top img img-responsive rounded-circle elevation-2 border"
                      alt="..."
                    />
                  </div>
                  <div class="text-center" v-else>
                    <img
                      :src="'https://backend-back-office.iapi.or.id/img_profile/' + formData.imageFile"
                      style="width:150px"
                      class="card-img-top img img-responsive rounded-circle elevation-2 border"
                      alt="..."
                    />
                  </div>

                </div>
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.statusDataDiri"
                  />
                  <label class="custom-control-label" for="aktif">Terverifikasi</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.statusDataDiri"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Anggota</h6>          
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postDataEmail">
          <CRow>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Subjek"
                placeholder="Masukkan Subjek"
                v-model="formEmail.subject"
              />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
                v-model="formEmail.text"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  @change="fileUpload"
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >{{ fileName }}</label>
              </div>
              <small class="text-danger">*File harus berupa PDF max 10MB</small>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>          
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton @click="postDataEmail" type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";

export default {
  name: "KeanggotaanDataDiri",
  el: "#app",
  data() {
    return {
      fileName: "Pilih File",
      details: {
        nama: "",
        email: "",
        no_handphone: "",
        tempat_lahir: "",
        tanggal_lahir: "",
        jenis_kelamin: "",
        image_profile: ""
      },
      formData: {
        idUser: "",
        statusDataDiri: "",
        verifikasiPada: new Date().toISOString().slice(0, 10),
        imageFile: ""
      },
      formEmail: {
        to: "",
        subject: "",
        text: "",
        attacment: ""
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  watch: {
    details: function(val) {
      // comment console console.log(val.tanggal_lahir);
    }
  },
  mounted() {
    this.getData();
    this.formData.idUser = this.$route.params.id_user;
  },
  methods: {
    alertSuccessSend() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Email Telah Terkirim"
      });
    },
    alertErrorSend() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Email Gagal Dikirim",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },
    updateDataDiri() {
      // var tanggalLahir = this.details.tanggal_lahir.split("-");  // ex input "2010-01-18"
      // var tanggalLahirUpdate = tanggalLahir[0]+ "-" +tanggalLahir[1]+ "-" +tanggalLahir[2];

      var formDataUpdate = {
        nama: this.details.nama,
        email: this.details.email,
        noTelephone: this.details.no_handphone,
        tempatLahir: this.details.tempat_lahir,
        tanggalLahir: this.details.tanggal_lahir,
        statusDataDiri: "",
        jenisKelamin: this.details.jenis_kelamin
      };
      DataKeanggotaanService.updateDataDiri(
        this.$route.params.id_user,
        formDataUpdate
      )
        .then(response => {
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    getData() {
      DataKeanggotaanService.getDataDiri(this.$route.params.id_user)
        .then(response => {
          this.details = response.data.data[0];
          this.formData.statusDataDiri = response.data.data[0].status_data_diri;
          var tanggalLahir = this.details.tanggal_lahir.split("-"); // ex input "2010-01-18"
          this.details.tanggal_lahir =
            tanggalLahir[0] +
            "-" +
            tanggalLahir[1] +
            "-" +
            tanggalLahir[2].substr(0, 2); //ex out: "18/01/10"
          // comment console console.log(this.details.tanggal_lahir);
          // comment console console.log(
          
          // comment console console.log("ini email" + response.data.data[0].email);
          var email = response.data.data[0].email;
          this.formEmail.to = email;

          var imageFile = response.data.data[0].image_profile;
          this.formData.imageFile = imageFile;

          // if (response.data.datadiri == null) {
          //   this.foto = "/img_profile/user.png";
          // } else {
          //   this.foto = "/img_profile/" + response.data.data[0].image_profile;
          // }

          // this.nama_file = "/img_profile/" + response.data.data[0].image_profile;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    postData() {
      DataKeanggotaanService.verifikasiDataDiri(this.formData)
        .then(response => {
          this.modalVerif = false;
          this.alertVerif();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    fileUpload(e) {
      this.formEmail.attacment = e.target.files[0];
      this.fileName = e.target.files[0].name;
    },

    sendEmail() {
      this.modalEmail = true;
      // this.formEmail = {};
    },
    postDataEmail() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DataKeanggotaanService.postSendMessage(this.formEmail)
        .then(response => {
          this.alertSuccessSend();
          loader.hide();
          this.modalEmail = false;
        })
        .catch(error => {
          loader.hide();
          this.alertErrorSend();
        });
    }
  }
};
</script>
